(function () {
  var FREE_SHIPPING_THRESHOLD = 3999;
  var CURRENCY = '$';

  function formatMoney(cents) {
    return CURRENCY + (cents / 100).toFixed(2);
  }

  function animateFill(el, targetPercent) {
    el.style.transition = 'width 0.4s ease';
    el.style.width = targetPercent + '%';
  }

  function updateBar(totalCents) {
    var fill = document.getElementById('psb-fill');
    var text = document.getElementById('psb-text');
    if (!fill || !text) return;

    fill.classList.remove('psb-fill-full');

    if (totalCents >= FREE_SHIPPING_THRESHOLD) {
      text.textContent = 'Your order qualifies for FREE delivery!';
      fill.classList.add('psb-fill-full');
      animateFill(fill, 100);
    } else if (totalCents > 0) {
      var remaining = FREE_SHIPPING_THRESHOLD - totalCents;
      var percent = Math.floor((totalCents / FREE_SHIPPING_THRESHOLD) * 100);
      text.textContent = 'Buy ' + formatMoney(remaining) + ' more to enjoy FREE Shipping';
      animateFill(fill, percent);
    } else {
      text.textContent = 'Buy ' + formatMoney(FREE_SHIPPING_THRESHOLD) + ' more to enjoy FREE Shipping';
      fill.style.width = '0%';
    }
  }

  function getProductTotal() {
    var priceEl = document.querySelector('.price--large .price-item--sale, .price--large .price-item--regular');
    var qtyEl = document.querySelector('.quantity__input');
    if (!priceEl) return 0;
    var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
    var price = parseFloat(priceText) || 0;
    var qty = qtyEl ? (parseInt(qtyEl.value) || 1) : 1;
    return Math.round(price * qty * 100);
  }

  function refresh() {
    updateBar(getProductTotal());
  }

  function init() {
    refresh();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(refresh, 300);
      });
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(refresh, 300);
      });
      subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
        setTimeout(refresh, 200);
      });
    }

    var qtyInput = document.querySelector('.quantity__input');
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        setTimeout(refresh, 100);
      });
    }

    var priceContainer = document.querySelector('.price--large');
    if (priceContainer) {
      var priceObserver = new MutationObserver(function () {
        setTimeout(refresh, 50);
      });
      priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
    }

    var productInfo = document.querySelector('product-info');
    if (productInfo) {
      var infoObserver = new MutationObserver(function () {
        setTimeout(refresh, 200);
      });
      infoObserver.observe(productInfo, { childList: true, subtree: true });
    }

    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
      var result = origFetch.apply(this, args);
      if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
        result.then(function () {
          setTimeout(refresh, 500);
        });
      }
      return result;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
